import { type RefObject, useEffect } from "react";
import { type MetaFunnelEvent, trackMetaEventOnce } from "./meta-pixel";

/** Once per document, when the element's top reaches the upper 60 % of the viewport. Works for tall sections. */
export function useMetaEventOnView(
  ref: RefObject<Element | null>,
  name: MetaFunnelEvent,
): void {
  useEffect(() => {
    const element: Element | null = ref.current;
    if (element === null) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        trackMetaEventOnce(name);
      },
      { rootMargin: "0px 0px -40% 0px" },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, name]);
}
